// =====================================================
// Store — localStorage-backed data for each company.
// Per-company: skattekonto, monthly vat-in/vat-out, monthly income/expense.
// MVP: lokalt. v2: Firestore eller D1.
// =====================================================

export interface MonthlyRow {
  month: number // 0..11
  vatIn: number
  vatOut: number
  income: number
  expense: number
}

export function emptyMonths(): MonthlyRow[] {
  return Array.from({ length: 12 }, (_, i) => ({
    month: i, vatIn: 0, vatOut: 0, income: 0, expense: 0,
  }))
}

export interface CompanyYearData {
  year: number
  skattekontoSaldo?: number
  skattekontoUpdated?: string // ISO date
  months: MonthlyRow[] // length 12
}

export function vatBalanceYTD(d: CompanyYearData, uptoMonthInclusive?: number) {
  const upto = uptoMonthInclusive ?? new Date().getMonth()
  let inSum = 0
  let outSum = 0
  for (let i = 0; i <= upto; i++) {
    inSum += d.months[i]?.vatIn ?? 0
    outSum += d.months[i]?.vatOut ?? 0
  }
  // "Att betala" = utgående - ingående (positivt = du betalar in)
  return { vatIn: inSum, vatOut: outSum, netToPay: outSum - inSum }
}

export function profitLossYTD(d: CompanyYearData, uptoMonthInclusive?: number) {
  const upto = uptoMonthInclusive ?? new Date().getMonth()
  let inc = 0
  let exp = 0
  for (let i = 0; i <= upto; i++) {
    inc += d.months[i]?.income ?? 0
    exp += d.months[i]?.expense ?? 0
  }
  return { income: inc, expense: exp, pl: inc - exp }
}
